module.exports = __webpack_public_path__ + "7eef172ac606cbcd14fe6fe23699b83e.svg";